import { gql } from 'apollo-angular'

export const USER_LIST_FIELDS = gql`
  fragment UserListFields on User {
    id
    name
    first_name
    last_name
    initials
    email
    isStudent
    locale
    roles
    last_logged_in
    _verified
  }
`

export const USER_FIELDS = gql`
  fragment UserFields on User {
    id
    name
    gender
    first_name
    last_name
    initials
    email
    isStudent
    locale
    _verified
    street
    house_number
    addition
    city
    province
    zip_code
    phone_number
    country
    locale
    last_logged_in
    createdAt
    emailVerifiedAt
    roles
    managed
    articleToPurchase {
      id
    }
  }
`
